<template>
	<div id="login">
		<Header></Header>
		<div class="login-box">
			<div class="login-bg">
				<img src="@/assets/login.png" alt="">
			</div>
			<div class="login-input">
				 <div class="title">用户登录</div>
				 <div>
					 <div class="user">
						<img src="@/assets/user.png" alt="">
						<el-input class="user-input" v-model="items.useracc" placeholder="请输入用户名"></el-input>
					 </div>
					 <div class="user">
						<img src="@/assets/passwords.png" alt="">
						<el-input type="password" class="user-input" v-model="items.userpw" placeholder="请输入密码"></el-input>
					 </div>
				 </div>
				 <div class="login-button">
					 <button style="outline:none;" @click="Login">登录</button>
				 </div>
				 <div class="other-login">
					 <div>第三方登录</div>
					 <div style="margin-left:10px;" @click="wxLogin" ><img  onmouseover="this.src='/static/image/wx2.png'"
					 onmouseout="this.src='/static/image/wx.png'"
					  src="/static/image/wx.png"></div>
					 <div style="margin-left:10px;" @click="qqLogin" id="qq_login_btn"><img onmouseover="this.src='/static/image/qq2.png'"
					  onmouseout="this.src='/static/image/qq.png'"
					  src="../../assets/qq.png"></div>
				 </div>
			</div>
		</div>
		<div class="login-foot">
			<div>本站系统 by SupeSite © 2001-20013 Comsenz Inc.</div>
			<div>Powered by 影音新时代网 © 2002-20015 家庭影院音响公众网络平台</div>
			<div>公安部备案： 61019002000037</div>
		</div>
		 <LoginBox :LoginBoxDialog.sync="LoginBoxDialog" :unionid="unionid" :openid="openid" :type="type"></LoginBox>
	</div>
</template>

<script>
	import md5 from 'js-md5';
	import LoginBox from '@/components/common/LoginBox'
	import Header from '@/components/twicehands/Header'
	import {setCookie,getCookie,clearCookie} from '@/common/js/common'
	export default {
		name: "Login",
		data(){
			return {
				items:{
					useracc:'',
					userpw:''
				},
				object:{
					self_redirect:true,
					scope: "snsapi_login", 
					redirect_uri: "",
					state: "",
					style: "black",
					href: ""
				},
				unionid:'',
				openid:'',
				LoginBoxDialog:false, //状态
				type:'' //１为qq  2为微信
			}
		},
	    components:{
            Header,
			LoginBox
        },
		computed:{
			code:function(){

				return this.getQueryString('code');
			}
		},
		created(){
			
			this.wxAccredit(this.code)
			this.qqAccredit()
		},
		methods:{
			qqAccredit(){
				if(QC.Login.check()){	//如果已登录
				let _this = this
					QC.Login.getMe(function(openId, accessToken)	{
						// 已经获取openid  进行判断，　如果为1001是首次登录则弹窗　如果成功存储cookie
					if (openId != '') {
						_this.$post('apis/web/qq/login', {openid:openId}).then((res) => {
							if (res.code == 1001) {
									_this.type  = 1
									_this.openid=openId
									_this.LoginBoxDialog = true
							}else{
								// 储存cookie
								setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
								window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
								_this.$router.push('/');
							}
						})
					}
					
					});
				}

			},
			getQueryString:function(name){
				var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r!=null)
					return  decodeURI(r[2]);
				return null;
			},
			Login(){
				if(this.items.useracc=='' && this.items.userpw==''){
					this.$message({
						type:'error',
						message:'用户名密码不能为空',
					})
					return;
				}
				this.$post('apis/common/login',{useracc:this.items.useracc,userpw:md5(this.items.userpw)}).then((res)=>{
					var _this=this;
					if(res){
						this.$message({
							message:'登录成功',
							type:'success',
							onClose:()=>{	
								// 储存cookie
								setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
								window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
								//请求同步登录代码 目前只同步登录www.hd199.com
								res.data.synlogin.forEach(function(value,index){
									if(value.indexOf('www.hd199.com')!==-1){
										_this.$get(value)
									}
								})
								this.$router.back(-1);
							}
						});
						if(res.data.synlogin){
							let synloginOne = res.data.synlogin[0].toString()
							let synloginTwo = res.data.synlogin[1].toString()
							this.$get(synloginOne,{})
							this.$get(synloginOne,{})
						}
					}
				})
			},
			close(){
				this.$emit('update:LoginDialog',false)
			},
			// 微信扫一扫登录
			wxLogin(){
				window.location.href='http://api.hd199.com/apis/wx/wx_sweep'
			},
			//qq登录
			qqLogin(){
				window.location.href="https://graph.qq.com/oauth2.0/authorize?client_id=101471183&response_type=token&scope=all&redirect_uri=http%3A%2F%2Fapi.hd199.com%2Fqqcallback?ref="+location.href;
				//window.open('https://graph.qq.com/oauth2.0/authorize?client_id=101471183&response_type=token&scope=all&redirect_uri=http%3A%2F%2Fapi.hd199.com%2Fqqcallback?ref='+location.href, 'oauth2Login_10109' ,'height=525,width=585, toolbar=no, menubar=no, scrollbars=no, status=no, location=yes, resizable=yes');
			},
			// 微信授权登录
			wxAccredit:function (value) {
				
				let _this=this;
				if (value != null) {
					this.$post('apis/web/wx/getInfo', {code: value}).then((res) => {
						if(res){
							let unionid=res.data.unionid;
							_this.openid=res.data.openid;
							_this.$post('apis/web/wx/login', {unionid: unionid}).then((res)=>{
								if(res){
									if (res.code == 1001) {
										_this.type  = 2
										_this.unionid=unionid
										_this.LoginBoxDialog = true
									}else{
										// 储存cookie
										setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
										window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
										_this.$router.push('/');
									}
								}
							})
						}
					})
				}
			},

		}
	}
</script>

<style>
#login .login-box{
	display: flex;
	min-width: 1200px;
	margin-top: 80px;
	display: flex;
	justify-content: center
}
#login .other-login{
	font-size: 14px;
	color: #7A7A7A;
	letter-spacing: 0;
	line-height: 3.75px;
	float: right;
	margin-top: 15px;
	line-height: 20px;
	display: flex;
	margin-right: 40px;
}
#login .login-bg img{
	width: 467px;
	height: 433px;
}
#login .login-bg{
	margin-left: 160px;
}
#login .login-input{
	width: 450px;
	height: 433px;
	border: 1px solid #F9C216 ;
	margin-left: 160px;
}
#login .title{
	font-size: 28px;
	text-align: center;
	color: #F9C216 ;
	margin-top: 40px;
}
#login .user{
	display: flex;
	align-items: center;
	border-bottom: 1px solid #f9c216;
	height: 60px;
    width: 84%;
    margin-left: 8%;
	margin-top: 15px;	
}
#login .el-input__inner{
	border: none;
}
#login .login-button button{
	border: none;
	background:#f9c216;
	color: #fff;
	width: 80%;
	height: 60px;
	margin-top: 50px;
	margin-left: 10%;
	font-size: 22px;
	outline:none;
}
#login .login-foot{
	text-align: center;
	font-size: 14px;
	color: #8D8D8D;
	margin-top: 88px;
}
#login .login-foot div{
	line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Login.vue